import React, { useState } from 'react';
import { textblocks } from 'seal-ui-components';
import {
    SystemPanelAddWrapper,
    ExpandablePanelWrapper,
    TitleWrapper
} from './ExpandablePanel.style';
import { layouts, buttons, icons } from 'seal-ui-components';

/** The "testid" prop does not contribute in anyway to this component,
 * it is only needed for testing purposes
 */
const ExpandablePanel = ({
    children,
    className,
    onToggleClick,
    controlledPanelCheck,
    testid,
    title,
    closePanel,
    ...rest
}) => {
    const [panelChecked, setPanelChecked] = useState(controlledPanelCheck);

    if (closePanel) {
        if (panelChecked !== controlledPanelCheck) {
            setPanelChecked(false);
        }
    }

    const toggleExpandableDiv = () => {
        setPanelChecked(!panelChecked);
        return onToggleClick && onToggleClick();
    };
    return (
        <ExpandablePanelWrapper {...rest} className={className}>
            <TitleWrapper data-testid="title">
                <textblocks.Heading4>{title}</textblocks.Heading4>
            </TitleWrapper>
            <SystemPanelAddWrapper data-testid="content-container" panelChecked={panelChecked}>
                {children}
            </SystemPanelAddWrapper>
            <layouts.VerticalBoxDivider />
            <buttons.IconButton
                data-testid={testid || 'toggle-button'}
                id="toggle_new_system_form"
                className="separator__Button"
                size="small"
                icon={panelChecked ? <icons.ChevronUpSmallIcon /> : <icons.ChevronDownSmallIcon />}
                onClick={() => toggleExpandableDiv()}
            />
        </ExpandablePanelWrapper>
    );
};

export default ExpandablePanel;
